(
    function (skyward, $, undefined)
    {
        skyward.programandrelatedservicetx = skyward.programandrelatedservicetx || {};
     
        var init = function (selector)
        {
            var detailsScreenSelector = $(selector).find("#editProgramAndRelatedServiceTX.currentRecordContent.dataObjectViewer");
            var workflowRelatedServiceCodeEel = $(selector).filter(".workflowContent");
            var selectedCodeEel;
     
            if (detailsScreenSelector.length > 0)
            {
                selectedCodeEel = detailsScreenSelector.find("#editProgramAndRelatedServiceTX_StateProgramAndRelatedServiceTypeCodeTXID");
                skyward.programandrelatedservicetx.showHideFields(false);
            }
            else if (workflowRelatedServiceCodeEel.length > 0)
            {
                selectedCodeEel = workflowRelatedServiceCodeEel.find("#ProgramAndRelatedServiceTXStateProgramAndRelatedServiceTypeCodeTXID");
            }
            else
            {
                return;
            }
     
            var serviceCodeOnChange = function ()
            {
                skyward.programandrelatedservicetx.showHideFields(true);
            };
     
            selectedCodeEel.on("eelComplete", serviceCodeOnChange);
        };
     
        skyward.programandrelatedservicetx.showHideFields = function (clearFields)
        {
            var relatedServiceCodeEelValue;
            
            var interpretingServicesCodeEel;
            var pPCDServiceLocationCodeEel;
            var districtOfRDSPDServicetxtBox;
            var interpretingServicesCodeEelCodeValue;
            var interpretingServicesCodeEelDescriptionValue;
            var interpretingServicesID;
            var pPCDServiceLocationCodeEelCodeValue;
            var pPCDServiceLocationCodeEelDescriptionValue;
            var pPCDServiceLocationID;
            var districtOfRDSPDServiceTextBoxValue;
     
            if ($("#editProgramAndRelatedServiceTX_StateProgramAndRelatedServiceTypeCodeTXID_description").length > 0)
            {
                var detailsEditScreenSelector = '#editProgramAndRelatedServiceTX_';
                relatedServiceCodeEelValue = $(detailsEditScreenSelector + "StateProgramAndRelatedServiceTypeCodeTXID_description").val();
                interpretingServicesCodeEel = $(detailsEditScreenSelector +'fsStateInterpretingServicesTypeCodeTXID');
                pPCDServiceLocationCodeEel = $(detailsEditScreenSelector + 'fsStatePPCDServiceLocationCodeTXID');
                districtOfRDSPDServicetxtBox = $(detailsEditScreenSelector + 'fsDistrictOfRDSPDService');
                interpretingServicesCodeEelCodeValue = $(detailsEditScreenSelector + 'StateInterpretingServicesTypeCodeTXID_code');
                interpretingServicesCodeEelDescriptionValue = $(detailsEditScreenSelector + 'StateInterpretingServicesTypeCodeTXID_description');
                interpretingServicesID = $(detailsEditScreenSelector + 'StateInterpretingServicesTypeCodeTXID_value');
                pPCDServiceLocationCodeEelCodeValue = $(detailsEditScreenSelector + 'StatePPCDServiceLocationCodeTXID_code');
                pPCDServiceLocationCodeEelDescriptionValue = $(detailsEditScreenSelector + 'StatePPCDServiceLocationCodeTXID_description');
                pPCDServiceLocationID = $(detailsEditScreenSelector + 'StatePPCDServiceLocationCodeTXID_value');
                districtOfRDSPDServiceTextBoxValue = $(detailsEditScreenSelector + 'DistrictOfRDSPDService');
            }
            else if ($("#ProgramAndRelatedServiceTXStateProgramAndRelatedServiceTypeCodeTXID_description").length > 0)
            {
                var workflowScreenSelector = '#ProgramAndRelatedServiceTX';
                relatedServiceCodeEelValue = $(workflowScreenSelector + "StateProgramAndRelatedServiceTypeCodeTXID_description").val();
                interpretingServicesCodeEel = $('#fsStateInterpretingServicesTypeCodeTXID');
                pPCDServiceLocationCodeEel = $('#fsStatePPCDServiceLocationCodeTXID');
                districtOfRDSPDServicetxtBox = $('#fsDistrictOfRDSPDService');
                interpretingServicesCodeEelCodeValue = $(workflowScreenSelector + 'StateInterpretingServicesTypeCodeTXID_code');
                interpretingServicesCodeEelDescriptionValue = $(workflowScreenSelector + 'StateInterpretingServicesTypeCodeTXID_description');
                interpretingServicesID = $(workflowScreenSelector + 'StateInterpretingServicesTypeCodeTXID_value');
                pPCDServiceLocationCodeEelCodeValue = $(workflowScreenSelector + 'StatePPCDServiceLocationCodeTXID_code');
                pPCDServiceLocationCodeEelDescriptionValue = $(workflowScreenSelector + 'StatePPCDServiceLocationCodeTXID_description');
                pPCDServiceLocationID = $(workflowScreenSelector + 'StatePPCDServiceLocationCodeTXID_value');
                districtOfRDSPDServiceTextBoxValue = $(workflowScreenSelector + 'DistrictOfRDSPDService');
            }
            else
            {
                return;
            }
     
            if (relatedServiceCodeEelValue.length > 0)
            {
                switch (relatedServiceCodeEelValue.toLowerCase())
                {
                    case "interpreting services":
                        interpretingServicesCodeEel.css('display', 'block');
                        pPCDServiceLocationCodeEel.css('display', 'none');
                        districtOfRDSPDServicetxtBox.css('display', 'none');
                        if (clearFields)
                        {
                            skyward.controls.setValue(pPCDServiceLocationCodeEelCodeValue, "");
                            skyward.controls.setValue(pPCDServiceLocationCodeEelDescriptionValue, "");
                            skyward.controls.setValue(pPCDServiceLocationID, "");
                            skyward.controls.setValue(districtOfRDSPDServiceTextBoxValue, "");
                        }
                        break;
                    case "early childhood special education":
                        interpretingServicesCodeEel.css('display', 'none');
                        pPCDServiceLocationCodeEel.css('display', 'block');
                        districtOfRDSPDServicetxtBox.css('display', 'none');
                        if (clearFields)
                        {
                            skyward.controls.setValue(interpretingServicesCodeEelCodeValue, "");
                            skyward.controls.setValue(interpretingServicesCodeEelDescriptionValue, "");
                            skyward.controls.setValue(interpretingServicesID, "");
                            skyward.controls.setValue(districtOfRDSPDServiceTextBoxValue, "");
                        }
                        break;
                    case "receiving instructional services from rdspd":
                        interpretingServicesCodeEel.css('display', 'none');
                        pPCDServiceLocationCodeEel.css('display', 'none');
                        districtOfRDSPDServicetxtBox.css('display', 'block');
                        if (clearFields)
                        {
                            skyward.controls.setValue(interpretingServicesCodeEelCodeValue, "");
                            skyward.controls.setValue(interpretingServicesCodeEelDescriptionValue, "");
                            skyward.controls.setValue(interpretingServicesID, "");
                            skyward.controls.setValue(pPCDServiceLocationCodeEelCodeValue, "");
                            skyward.controls.setValue(pPCDServiceLocationCodeEelDescriptionValue, "");
                            skyward.controls.setValue(pPCDServiceLocationID, "");
                        }
                        break;
                    default:
                        interpretingServicesCodeEel.css('display', 'none');
                        pPCDServiceLocationCodeEel.css('display', 'none');
                        districtOfRDSPDServicetxtBox.css('display', 'none');
                        if (clearFields)
                        {
                            skyward.controls.setValue(interpretingServicesCodeEelCodeValue, "");
                            skyward.controls.setValue(interpretingServicesCodeEelDescriptionValue, "");
                            skyward.controls.setValue(interpretingServicesID, "");
                            skyward.controls.setValue(pPCDServiceLocationCodeEelCodeValue, "");
                            skyward.controls.setValue(pPCDServiceLocationCodeEelDescriptionValue, "");
                            skyward.controls.setValue(pPCDServiceLocationID, "");
                            skyward.controls.setValue(districtOfRDSPDServiceTextBoxValue, "");
                        }
                        break;
                }
            }
            else
            {
                skyward.controls.setValue(interpretingServicesCodeEelCodeValue, "");
                skyward.controls.setValue(interpretingServicesCodeEelDescriptionValue, "");
                skyward.controls.setValue(interpretingServicesID, "");
                skyward.controls.setValue(pPCDServiceLocationCodeEelCodeValue, "");
                skyward.controls.setValue(pPCDServiceLocationCodeEelDescriptionValue, "");
                skyward.controls.setValue(pPCDServiceLocationID, "");
                skyward.controls.setValue(districtOfRDSPDServiceTextBoxValue, "");

                interpretingServicesCodeEel.css('display', 'none');
                pPCDServiceLocationCodeEel.css('display', 'none');
                districtOfRDSPDServicetxtBox.css('display', 'none');
            }
        };
     
        skyward.window.registerLoadDOMCallback(init);
     
    }(window.skyward = window.skyward || {}, window.jQuery)
);